import { Detail, Heading, List } from '@farol-ds/react'
import { ReactNode } from 'react'

import styles from './doc-details.module.scss'

export interface DocDetailsProps {
  title?: string
  pairs: Array<{ label: string; value: ReactNode }>
  onCopy?: () => void
}

export function DocDetails(props: DocDetailsProps) {
  const { title = 'Detalhes', pairs, onCopy } = props

  if (pairs.length === 0) {
    return null
  }

  return (
    <div>
      <Heading size="md" className={styles.cardTitle} asChild>
        <h2>{title}</h2>
      </Heading>
      <List className={styles.cardContent} data-testid="doc-details" onCopy={onCopy}>
        {pairs.map(({ label, value }, index) => (
          <List.Item key={index}>
            <Detail>
              <Detail.Label>{label}</Detail.Label>
              <Detail.Value asChild>
                <div>{value}</div>
              </Detail.Value>
            </Detail>
          </List.Item>
        ))}
      </List>
    </div>
  )
}
